var OR_FILTER_KEY = 'satisfy';

/**
 *
 * @constructor
 */
function QueryParamBuilder() {
	this.params = {
		filter: {}
	};
	this.returnParams = {
		'filter[]': []
	};
	this.satisfy = null;
}

/**
 *
 * @param field
 * @param value
 * @param type
 */
QueryParamBuilder.prototype.addFilterParam = function (field, value, type) {
	var isObject = angular.isObject(field);
	var filterName = isObject ? field.filterName : field;
	var fieldName = isObject ? field.fieldName : field;

	this.params.filter[filterName] = {
		field: fieldName,
		value: value,
		type: type || 'eq'
	};
};

/**
 *
 * @param filters
 */
QueryParamBuilder.prototype.setQueryTypeOr = function () {
	this.addQueryParam(OR_FILTER_KEY, 'any');
};

/**
 *
 * @param params
 */
QueryParamBuilder.prototype.setParams = function (params) {
	this.params = params;
	this.resetReturnParams();
};

/**
 *
 */
QueryParamBuilder.prototype.reset = function () {
	this.params = {
		filter: {}
	};
	this.resetReturnParams();
};

/**
 *
 */
QueryParamBuilder.prototype.resetFilterParams = function () {
	this.params = {
		filter: {}
	};
};


/**
 *
 */
QueryParamBuilder.prototype.resetReturnParams = function () {
	this.returnParams = {
		'filter[]': []
	};
};

/**
 *
 * @param params
 */
QueryParamBuilder.prototype.setFilterParams = function (params) {
	this.params.filter = params;
	this.resetReturnParams();
};

/**
 *
 * @param fieldName
 */
QueryParamBuilder.prototype.removeFilterParam = function (fieldName) {
	var filters = this.params.filter;
	for (var filter in filters) {
		if (filters[filter].field == fieldName) {
			delete filters[filter];
		}
	}
};

/**
 *
 * @param paramName
 */
QueryParamBuilder.prototype.removeQueryParam = function (paramName) {
	delete this.params[paramName];
};

/**
 *
 * @param key
 * @returns {boolean}
 */
QueryParamBuilder.prototype.hasQueryParam = function (key) {
	return !!this.params[key];
};

/**
 *
 * @param key
 * @returns {boolean}
 */
QueryParamBuilder.prototype.hasFilterParam = function () {
	var filters = this.params.filter;
	var hasFilterParam = false;
	for (var filter in filters) {
		if (filters[filter].field == fieldName) {
			hasFilterParam = true;
			break;
		}
	}
	return hasFilterParam;
};

/**
 *
 * @param key
 * @param value
 */
QueryParamBuilder.prototype.addQueryParam = function (key, value) {
	this.params[key] = value;
};

/**
 *
 * @returns {*|{filter: {}}|{filter: {}, orFilters: Array}}
 */
QueryParamBuilder.prototype.getParams = function () {
	return this.params;
};

/**
 *
 * @returns {{filter[]: Array}|*|Object|void}
 */
QueryParamBuilder.prototype.build = function () {
	this.resetReturnParams();

	this.returnParams = angular.extend({}, this.returnParams, this.params);

	if (this.returnParams.filter) {
		buildFilterParam(this.returnParams.filter, this.returnParams);
	}


	delete this.returnParams.filter;
	return this.returnParams;
};

/**
 *
 * @param filterParams
 * @param returnParams
 */
function buildFilterParam(filterParams, returnParams) {
	Object.keys(filterParams).forEach(function (key) {
		returnParams['filter[]'].push(createFilterParam(filterParams[key].field, filterParams[key].value, filterParams[key].type));
	});
}

/**
 *
 * @param key
 * @param value
 * @param type
 * @returns {string}
 */
function createFilterParam(key, value, type) {
	var param = '';
	switch (type) {
		case 'eq' :
			param = createFilterParamEq(key, value);
			break;
		case 'neq':
		case 'ne':
			param = createFilterParamNeq(key, value);
			break;
		case 'lte':
		case 'le':
			param = createFilterParamLte(key, value);
			break;
		case 'gte':
		case 'ge' :
			param = createFilterParamGte(key, value);
			break;
		case 'gt':
			param = createFilterParamGt(key, value);
			break;
		case 'is' :
			param = createFilterParamIsNull(key);
			break;
		case 'no' :
			param = createFilterParamIsNotNull(key);
			break;
		case 'in' :
			param = createFilterParamIn(key, value);
			break;
		case 'like':
			param = createFilterParamLike(key, value);
			break;
		case 'plike':
			param = createFilterParamPLike(key, value);
			break;
		case 'nlike':
		case 'notlike':
			param = createFilterParamNotLike(key, value);
			break;
		case "sw":
			param = createFilterParamSw(key, value);
			break;
	}
	return param;
}

/**
 *
 * @param key
 * @param value
 * @returns {string}
 */
function createFilterParamEq(key, value) {
	return [key, 'eq', value].join(',');
}

/**
 *
 * @param key
 * @param value
 * @returns {string}
 */
function createFilterParamNeq(key, value) {
	return [key, 'ne', value].join(',');
}

/**
 *
 * @param key
 * @param value
 * @returns {string}
 */
function createFilterParamLte(key, value) {
	return [key, 'le', value].join(',');
}

/**
 *
 * @param key
 * @param value
 * @returns {string}
 */
function createFilterParamGte(key, value) {
	return [key, 'ge', value].join(',');
}

/**
 *
 * @param key
 * @param value
 * @returns {string}
 */
function createFilterParamGt(key, value) {
	return [key, 'gt', value].join(',');
}

/**
 *
 * @param key
 * @returns {string}
 */
function createFilterParamIsNull(key) {
	return [key, 'is'].join(',');
}

/**
 *
 * @param key
 * @returns {string}
 */
function createFilterParamIsNotNull(key) {
	return [key, 'no'].join(',');
}

/**
 *
 * @param key
 * @param value
 * @returns {string}
 */
function createFilterParamIn(key, value) {
	return [key, 'in', value.join(',')].join(',');
}
/**
 *
 * @param key
 * @param value
 * @returns {string}
 */
function createFilterParamLike(key, value) {
	return [key, 'cs', value].join(',');
}

/**
 *
 * @param key
 * @param value
 * @returns {string}
 */
function createFilterParamPLike(key, value) {
	return [key, 'like', value].join(',');
}

/**
 *
 * @param key
 * @param value
 * @returns {string}
 */
function createFilterParamNotLike(key, value) {
	return [key, 'notlike', value].join(',');
}

/**
 *
 * @param key
 * @param value
 * @returns {string}
 */
function createFilterParamSw(key, value) {
	return [key, 'sw', value].join(',');
}

/**
 *
 *
 * @param paramObj
 * @param returnParams
 * @returns {boolean}
 */
function buildFromToFilter(paramObj, returnParams) {
	if (!paramObj.from && !paramObj.to) {
		return false;
	}

	if (paramObj.from) {
		returnParams['filter[]'].push(createFilterParamGte(paramObj.field, paramObj.from));
	}

	if (paramObj.to) {
		returnParams['filter[]'].push(createFilterParamLte(paramObj.field, paramObj.to));
	}
}

export default QueryParamBuilder;
